import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useIsAdmin } from "../../auth/useIsAdmin";

/**
 * Gates the admin routes to users in the Cognito `admins` group. Sits INSIDE
 * `ProtectedRoute` (so the caller is already authenticated); a non-admin is
 * bounced to the dashboard rather than the login flow. This is a UI gate only —
 * every `/admin/**` API endpoint independently enforces the group server-side.
 */
export function AdminRoute({ children }: { children: ReactNode }): ReactNode {
  const isAdmin = useIsAdmin();
  if (!isAdmin) return <Navigate to="/" replace />;
  return children;
}
